import { branch, compose, lifecycle, renderComponent, withHandlers, withProps, withState } from 'recompose';
import { connect } from 'react-redux';
import { get } from 'lodash';

import StaffForm from './StaffFormContainer';
import Spinner from '../../../common/Spinner';
import { getInitialValuesFromUser } from '../../../admin/users/helpers/form';
import { fetchStaffMember, updateStaffMember, deleteStaffMember } from '../actions';
import { getCurrentUserId, getShopBrand, getShopBrandId, getUserUrlPrefix } from '../../../auth/selectors';
import withPermissions from '../../../auth/utils/withPermissions';
import { canUserModifyStaffManagement } from '../../../common/helpers/users';
import { prepareApiUpdate } from './helpers';
import withOwnerTypeAndId from '../../../common/hoc/withOwnerTypeAndId';
import withNotifications from '../../../common/withNotifications';
import confirmModal from '../../../common/confirmModal';
import withUnsavedChangesCheck, { withGoToUrl } from './withUnsavedChangesCheck';
import { t } from '../../../../modules/infra/i18n';

const enhance = compose(
  withOwnerTypeAndId,
  withNotifications,
  connect((state, ownProps) => ({
    brandId: getShopBrandId(state),
    isEditingSelf: getCurrentUserId(state) === ownProps.params.staffId,
    isEditingAccountOwner: get(getShopBrand(state), 'settings.primaryAccountOwner') === ownProps.params.staffId,
    baseUrl: `${getUserUrlPrefix(state)}/staff`,
  })),
  withPermissions,
  withState('staffUser', 'setStaffUser', null),
  withProps((props) => ({
    initialValues: props.staffUser ? getInitialValuesFromUser(props.staffUser) : {},
    canModifyStaff: canUserModifyStaffManagement(props.permissions),
    edit: true,
    tmpPassword: props.router.location.state && props.router.location.state.tmpPassword,
  })),
  withState('busy', 'setBusy', false),
  withGoToUrl,
  withHandlers({
    onSubmit:
      (props) =>
      (data, redirectUrl = props.baseUrl) => {
        props.setBusy(true);
        const update = prepareApiUpdate(data, props.brandId);
        updateStaffMember(props.brandId, props.params.staffId, update)
          .then(() => {
            props.addNotification({
              title: t('common:success'),
              level: 'success',
              message: t('barber:staff.edit.success_message'),
            });

            props.goToUrl(redirectUrl);
          })
          .catch(() => props.setBusy(false));
      },
    onDelete: (props) => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: t('barber:staff.delete.modal_title'),
        message: t('barber:staff.delete.modal_message'),
      });

      if (confirmed) {
        props.setBusy(true);
        deleteStaffMember(props.params.staffId)
          .then(() => {
            props.goToUrl(props.baseUrl);
          })
          .catch(() => props.setBusy(false));
      }
    },
  }),
  withUnsavedChangesCheck,
  lifecycle({
    componentWillMount() {
      fetchStaffMember(this.props.ownerType, this.props.ownerId, this.props.params.staffId).then((response) => {
        this.props.setStaffUser(response);
      });
    },
  }),
  branch((props) => !props.staffUser, renderComponent(Spinner))
);

export default enhance(StaffForm);
